import React from 'react';
import Box from "@material-ui/core/Box";

export default function TotalPaypal(props) {
  
  
  var total_price = 0.0;
  var subtotal_price = 0.0;
 
  
 
 
  subtotal_price = sessionStorage.getItem('QR_price_int')
    
  var admin_price = sessionStorage.getItem('admin_price');
 
  var gateway_credit_card = sessionStorage.getItem('gateway_credit_card');
  var gateway_total = sessionStorage.getItem('gateway_total');

 

  total_price = sessionStorage.getItem('QR_price')
  total_price = sessionStorage.getItem('QR_price')

  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });


  return (
  

  <div>
  
  
 
          
  <Box display="flex"  bgcolor="background.paper"
  alignItems="center"
  justifyContent="center"
  >
        
        <Box >
          
        <div style={{textAlign: 'right'}}><strong>Interest</strong> {}</div>
        <div style={{textAlign: 'right'}}><strong>Admin Fee</strong> {}</div>
        <div style={{textAlign: 'right'}}><strong>Transaction Fee</strong> {}</div>
        <br></br>
        <div style={{textAlign: 'right'}}><strong>Total Amount</strong> {}</div>
        
        </Box>
       
        <Box >
        <div style={{textAlign: 'right',marginLeft: '10px' }}><strong>:</strong> {}</div>
        <div style={{textAlign: 'right'}}><strong>:</strong> {}</div>
        <div style={{textAlign: 'right'}}><strong>:</strong> {}</div>
        <br></br>
        <div style={{textAlign: 'right'}}><strong>:</strong> {}</div>
        </Box>
       
        <Box >
      
        <div style={{textAlign: 'right',marginLeft: '10px'}}> <strong>{formatter.format(subtotal_price)}</strong></div>
          <div style={{textAlign: 'right'}}> <strong>{formatter.format(admin_price)}</strong></div>
          <div style={{textAlign: 'right'}}> <strong>{formatter.format(gateway_credit_card)}</strong></div>
          <br></br>
          <div style={{textAlign: 'right'}}> <strong>{formatter.format(total_price)}</strong></div>
      
        </Box>
      </Box>

  
  </div>
  
  
  );


  // <div style={{textAlign: 'right',marginLeft: '10px'}}> <strong>{formatter.format(subtotal_price)}</strong></div>
  //<div style={{textAlign: 'right'}}> <strong>{formatter.format(gateway_credit_card)}</strong></div>
 // <div style={{textAlign: 'right'}}> <strong>{formatter.format(admin_price)}</strong></div>
 // <div style={{textAlign: 'right'}}> <strong>{formatter.format(total_price)}</strong></div>
  //
  //
  //
}
 